import { Outlet, useMatch } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { FieldPage } from '@/features/field/pages/field-page';
import { WorkshopDetailPage } from '@/features/workshop/pages/workshop-detail-page';

import { PlacementGate } from './placement-gate';

/** Preserve editor buffers and draft autosave during app navigation, until sign-out unmounts us. */
export function AuthenticatedLayout() {
  const match = useMatch({ from: '/app/workshop/$activityId', shouldThrow: false });
  const fieldMatch = useMatch({ from: '/app/field', shouldThrow: false });
  const fieldVisible = Boolean(fieldMatch);
  const [fieldVisited, setFieldVisited] = useState(fieldVisible);
  useEffect(() => {
    if (fieldVisible) setFieldVisited(true);
  }, [fieldVisible]);
  const requested = match?.params.activityId ?? null;
  const [lastActivity, setLastActivity] = useState(requested);
  useEffect(() => {
    if (requested) setLastActivity(requested);
  }, [requested]);
  const activityId = requested ?? lastActivity;
  return (
    <>
      <Outlet />
      <PlacementGate />
      <div hidden={!fieldVisible} inert={!fieldVisible}>
        {fieldVisible || fieldVisited ? <FieldPage visible={fieldVisible} /> : null}
      </div>
      <div hidden={!requested} inert={!requested}>
        {activityId ? (
          <WorkshopDetailPage activityId={activityId} visible={Boolean(requested)} />
        ) : null}
      </div>
    </>
  );
}
